








import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: {
      Comment,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 点击更多
      handleMoreClick = () => {
        navigateTo('CommentIndex', {
          id: this.goodsData.value.commodityId,
        })
      }
    },
)
